import React from "react"

export default function Option({ children, value, optionStyles }) {
  return (
    <option value={value} style={optionStyles}>
      {children}
    </option>
  )
}
